import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enHome from "../en/home.json";
import frHome from "../fr/home_fr.json";
import arHome from "../ar/home_ar.json";

import enSettings from "../en/settings.json";
import frSettings from "../fr/settings_fr.json";
import arSettings from "../ar/settings_ar.json";

import enMenu from "../en/menu.json";
import frMenu from "../fr/menu_fr.json";
import arMenu from "../ar/menu_ar.json";

import enHeader from "../en/header.json";
import frHeader from "../fr/header_fr.json";
import arHeader from "../ar/header_ar.json";

import enSchedule from "../en/schedule.json";
import frSchedule from "../fr/schedule_fr.json";
import arSchedule from "../ar/schedule_ar.json";


import enAbout from "../en/about.json";
import frAbout from "../fr/about_fr.json";
import arAbout from "../ar/about_ar.json";

import enMessages from "../en/messages.json";
import frMessages from "../fr/messages_fr.json";
import arMessages from "../ar/messages_ar.json";

import enOnCallLookup from "../en/OnCallLookUp.json";
import frOnCallLookup from "../fr/OnCallLookUp_fr.json";
import arOnCallLookup from "../ar/OnCallLookUp_ar.json";

import enTeams from "../en/teams.json";
import frTeams from "../fr/teams_fr.json";
import arTeams from "../ar/teams_ar.json";

import enSites from "../en/sites.json";
import frSites from "../fr/sites_fr.json";
import arSites from "../ar/sites_ar.json";

import enEms from "../en/ems.json";
import frEms from "../fr/ems_fr.json";
import arEms from "../ar/ems_ar.json";

import enStatusBoard from "../en/statusboard.json";
import frStatusBoard from "../fr/statusboard_fr.json";
import arStatusBoard from "../ar/statusboard_ar.json";

import enNotifications from "../en/notifications.json";
import frNotifications from "../fr/notifications_fr.json";
import arNotifications from "../ar/notifications_ar.json";

import enPatients from "../en/patients.json";
import frPatients from "../fr/patients_fr.json";
import arPatients from "../ar/patients_ar.json";

import enUnassignedShifts from "../en/unassignedShifts.json";
import frUnassignedShifts from "../fr/unassignedShifts_fr.json";
import arUnassignedShifts from "../ar/unassignedShifts_ar.json";

import enNursemanagement from "../en/nursemanagement.json";
import frNursemanagement from "../fr/nursemanagement_fr.json";
import arNursemanagement from "../ar/nursemanagement_ar.json";

import enCall from "../en/call.json";
import frCall from "../fr/call_fr.json";
import arCall from "../ar/call_ar.json";

import enLogin from "../en/login.json";
import frLogin from "../fr/login_fr.json";
import arLogin from "../ar/login_ar.json";

import { DEFAULT_LANGUAGE, LANGUAGES, applyDirection } from "./languages";

const supportedLanguages = LANGUAGES.map((option) => option.value);

// A stale or hand-edited localStorage value would otherwise be handed straight
// to i18next, leaving every key unresolved on screen.
const storedLanguage = localStorage.getItem("appLanguage");
const initialLanguage =
  storedLanguage && supportedLanguages.includes(storedLanguage)
    ? storedLanguage
    : DEFAULT_LANGUAGE;

i18n.use(initReactI18next).init({
  resources: {
    en: { home: enHome, settings: enSettings, menu: enMenu, header: enHeader, schedule: enSchedule, about: enAbout, messages: enMessages, onCallLookup: enOnCallLookup, teams: enTeams, sites: enSites, ems: enEms, statusBoard: enStatusBoard, notifications: enNotifications, patients: enPatients, unassignedShifts: enUnassignedShifts, nursemanagement: enNursemanagement, call: enCall, login: enLogin },
    fr: { home: frHome, settings: frSettings, menu: frMenu, header: frHeader, schedule: frSchedule, about: frAbout, messages: frMessages, onCallLookup: frOnCallLookup, teams: frTeams, sites: frSites, ems: frEms, statusBoard: frStatusBoard, notifications: frNotifications, patients: frPatients, unassignedShifts: frUnassignedShifts, nursemanagement: frNursemanagement, call: frCall, login: frLogin },
    ar: { home: arHome, settings: arSettings, menu: arMenu, header: arHeader, schedule: arSchedule, about: arAbout, messages: arMessages, onCallLookup: arOnCallLookup, teams: arTeams, sites: arSites, ems: arEms, statusBoard: arStatusBoard, notifications: arNotifications, patients: arPatients, unassignedShifts: arUnassignedShifts, nursemanagement: arNursemanagement, call: arCall, login: arLogin },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  ns: ["home","menu","settings","header","schedule","about","messages","onCallLookup","teams","sites","ems","statusBoard","notifications","patients","unassignedShifts","nursemanagement","call","login"],
  defaultNS: "home",
  interpolation: {
    escapeValue: false,
  },
});

// Set <html dir>/<html lang> for the starting language and keep them in step
// afterwards. Registered here rather than in a component because the client is
// an Ionic app with several independent entry points (login, /user-activate, the
// authenticated shell) -- a single component would leave the others LTR.
applyDirection(initialLanguage);
i18n.on("languageChanged", applyDirection);

export default i18n;
